import React, { useEffect, useState } from "react";
import "./SkillCard.css";
import { useInView } from "react-intersection-observer";

function SkillCard({ name, level }) {
  const { ref, inView } = useInView({ threshold: 0.5 });
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (inView) {
      let start = 0;
      const step = level / 50;
      const interval = setInterval(() => {
        start += step;
        if (start >= level) {
          setCount(level);
          clearInterval(interval);
        } else {
          setCount(Math.ceil(start));
        }
      }, 30);
    }
  }, [inView, level]);
  return (
    <div
      className={`skills-tree-skill ${inView ? "" : "yet"}`}
      key={name}
      ref={ref}
    >
      <span className="skills-tree-skill-name">{name}</span>
      <div className="skills-tree-progress-bar">
        <div
          className="skills-tree-progress"
          style={{ width: inView ? `${level}%` : "0" }}
        ></div>
      </div>
      <span className="skills-tree-skill-level">{count}%</span>
    </div>
  );
}

export default SkillCard;
